import object from 'helpers/object'
import moment from 'moment'


const year            = new Date().getFullYear()
const month           = new Date().getMonth()
const firstDayOfMonth = moment([ year, month ])


const _initialState = {
  list: {
    contractor: [ 'МУП ГорАвтоТранс' ],
    buses: [],
    routes: [],
  },

  drivers: {
    brigadeId: [],
    driversId: [],
    date: firstDayOfMonth,
  },
  conductors: {
    conductorsId: [],
    date: firstDayOfMonth,
  },
  buses: {
    busesIdList: [],
    date: firstDayOfMonth,
  },
  order: {
    date: moment(new Date()),
  },
  report: {
    form: 'Путевые листы',
    driversId: [],
    date: moment(new Date()),
  }
}

export const initialState = _initialState

export const resetDate = (state, payload) => {
  const year            = new Date().getFullYear()
  const month           = new Date().getMonth()
  const firstDayOfMonth = moment([ year, month ])

  if ([ 'drivers', 'conductors', 'buses' ].includes(payload)) {
    return object.setIn(state, [ payload, 'date' ], firstDayOfMonth)
  }
  else if ([ 'order', 'report' ].includes(payload)) {
    return object.setIn(state, [ payload, 'date' ], moment(new Date()))
  }
}

export const clear = (state, payload) =>
  object.setIn(state, [ payload.type ], _initialState[payload.type])

export const setDate = (state, payload) =>
  object.setIn(state, [ payload.type, 'date' ], payload.date)

export const setFilter = (state, payload) =>
  object.setIn(state, [ payload.type, payload.filterType ], payload.data)

export const setFilterMultiple = (state, payload) =>
  object.updateIn(state, [ payload.type, payload.filterType ], (filterData) => filterData.includes(payload.data)
    ? filterData.filter((filterItem) => filterItem !== payload.data)
    : filterData.concat(payload.data)
  )

export const setList = (state, payload) =>
  object.setIn(state, [ 'list', payload.type ], payload.data)
